import React, { useState } from "react";
import {
  BasePageLayout,
  BaseBox,
  BaseTypography,
  BaseTextField,
  BaseButton,
  BasePre,
} from "../../../Common/UI/exports";
import {
  retrieveParameters,
  createParameter,
  updateParameter,
  rollbackParameter,
} from "../../../APIs/AwsParameterManager";

function AwsParameterStoreManager() {
  const email = localStorage.getItem("email");

  const [parameterName, setParameterName] = useState("");
  const [parameterValue, setParameterValue] = useState("");
  const [response, setResponse] = useState(null);

  const handleAction = async (action) => {
    try {
      let data;

      // normalize parameter name to always start with '/'
      const nameTrimmed = parameterName ? parameterName.trim() : parameterName;
      const normalizedParameterName =
        nameTrimmed && nameTrimmed.length > 0
          ? nameTrimmed.startsWith("/")
            ? nameTrimmed
            : `/${nameTrimmed}`
          : nameTrimmed;

      const parsedValue =
        parameterValue && parameterValue.trim() !== ""
          ? JSON.parse(parameterValue)
          : {};

      switch (action) {
        case "create":
          data = await createParameter(normalizedParameterName, parsedValue);
          break;
        case "update":
          data = await updateParameter(normalizedParameterName, parsedValue);
          break;
        case "get":
          data = await retrieveParameters(normalizedParameterName);
          break;
        case "rollback":
          data = await rollbackParameter(normalizedParameterName);
          break;
        case "clear_response":
          data = null;
          break;
        default:
          return;
      }

      setResponse(data);
    } catch (err) {
      console.error(err);
      setResponse({
        error: err.response?.data || err.message,
      });
    }
  };

  return (
    <BasePageLayout sidebarItems={[]}>
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          AWS parameter Store Manager
        </BaseTypography>

        <BaseBox sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <BaseTextField
            label="Parameter Name"
            placeholder="Enter parameter name"
            value={parameterName}
            onChange={(e) => setParameterName(e.target.value)}
            fullWidth={false}
            sx={{ width: "20%" }}
          />

          <BaseTextField
            label="Parameter Data"
            value={parameterValue}
            onChange={(e) => setParameterValue(e.target.value)}
            fullWidth
            multiline
            rows={8}
          />

          {/* Buttons below table */}
          <BaseBox sx={{ display: "flex", gap: 2, mt: 2 }}>
            <BaseButton
              onClick={() => handleAction("clear_response")}
              color="info"
            >
              Clear Response
            </BaseButton>
            <BaseButton onClick={() => handleAction("get")} color="secondary">
              Get
            </BaseButton>
            <BaseButton
              onClick={() => handleAction("rollback")}
              color="secondary"
            >
              Rollback
            </BaseButton>
            <BaseButton onClick={() => handleAction("update")} color="primary">
              Update
            </BaseButton>
            <BaseButton onClick={() => handleAction("create")} color="primary">
              Create
            </BaseButton>
          </BaseBox>
        </BaseBox>

        <BaseBox sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <BaseTextField
            label="Response"
            value={response ? JSON.stringify(response, null, 2) : ""}
            fullWidth
            multiline
            rows={8}
          />
        </BaseBox>
      </BaseBox>
    </BasePageLayout>
  );
}

export default AwsParameterStoreManager;
